import _ from 'lodash';
export const checkActiveInfo = (info) => {
  const data = _.cloneDeep(info || {});
  let flag = false;
  const { sku, name } = data;
  if (!sku) {
    flag = true;
    data.skuError = true;
  }
  if (!name) {
    flag = true;
    data.nameError = true;
  }
  //   if (!(measurementUnit && measurementUnit.uuid)) {
  //     flag = true;
  //     data.measurementUnitError = true;
  //   }
  //   if (!remarks) {
  //     flag = true;
  //     data.remarksError = true;
  //   }
  //   if (!description) {
  //     flag = true;
  //     data.descriptionError = true;
  //   }

  //   if (!barcode) {
  //     flag = true;
  //     data.barcodeError = true;
  //   }
  return { flag, data };
};
export const checkDraftInfo = (info) => {
  const data = _.cloneDeep(info || {});
  let flag = false;
  const { name } = data;

  if (!name) {
    flag = true;
    data.nameError = true;
  }

  return { flag, data };
};
